<template>
  <section class="page">
    <div class="shape">
      <img src="@/assets/img/animation.png"/>
    </div>
    <svg class="animation" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><text data-name="+" transform="matrix(1.437 1.434 -1.437 1.434 -.832 23.066)" font-size="25" fill="#27eac8" text-anchor="middle" font-family="Roboto"><tspan x="0">+</tspan></text></svg>
    <div class="shape2">
      <img src="@/assets/img/animated-bg2.png"/>
    </div>
    <svg class="shape3" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="-49.891%" id="a">
          <stop stop-color="#00E92B" offset="0%"/>
          <stop stop-color="#CCFFA8" offset="100%"/>
        </linearGradient>
      </defs>
      <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
    </svg>
    <div class="page-content">
      <div class="title">
        <!-- <div class="shape">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.562" height="28.594"><circle cx="14.281" cy="14.297" r="12.781" fill="none" stroke="#e1e1e1" stroke-width="3"/></svg>
        </div> -->
        <div class="box">
          <div class="ball-box">
             <svg class="ball" xmlns="http://www.w3.org/2000/svg" width="28.562" height="28.594"><circle cx="14.281" cy="14.297" r="12.781" fill="none" stroke="#e1e1e1" stroke-width="3"/></svg>
          </div>
        </div>
        <h2 class="content">关于我们</h2>
        <div class="box2">
          <div class="triangle-ball">
             <svg class="triangle" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
              <!-- <defs>
                <linearGradient x1="50%" y1="100%" x2="50%" y2="-49.891%" id="a">
                  <stop stop-color="#00E92B" offset="0%"/>
                  <stop stop-color="#CCFFA8" offset="100%"/>
                </linearGradient>
              </defs> -->
              <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="page-content-top">
        <div class="image" >
          <img class="animated pulse" src="@/assets/img/about.png"/>
        </div>
        <div class="introduction">
          <h2 class="subtitle">公司简介</h2>
          <span class="spacing"></span>
          <p class="paragraph">
            哈尔滨东悟科技有限公司是一家中外合资企业。公司注册成立于2013年，注册资本贰仟万元整。
            公司位于哈尔滨松北区科技创新城，现有职工50余人，哈尔滨东悟科技有限公司主营业务为软
            件开发，BPO流程外包，电子商务运营的设计、研制、开发为主的IT高科技专业化公司，通过人
            才选拔机制及人才培养系统，公司不断充实壮大队伍建设，具有广阔的发展空间。
          </p>
          <p class="paragraph">
           公司于2017年在深圳产权文化交易所授权上市，公司佣有多年工业物联网领域产品
           研发团队；拥有大批曾在日本进修和工作过、业务经验丰富的高级研发人员。
          </p>
          <p class="paragraph">
            公司的未来将持续以“科学发展观，高科技创新创业”为指导，坚持“以人为本、科学发展”的方针，
            深化改革，建立和完善现代企业管理制度，通过科技手段创新、商业模式创新等手段产生经济效
            益，加快人才培养步伐，创造有利条件调动广大科研人员积极性，创造性，培养出一支勤于学习、
            爱岗敬业、思想先进、创新意识强的科研队伍；加强基础管理，不断提高管理水平和创新能力；进
            一步优化和创新方案，提高产品科技含量和成果转化能力，打造具有自主知识产权和现代化生产力
            的科技技术行企业。
          </p>
        </div>
      </div>
      <div class="page-content-bottom">
        <div class="page-content-bottom-item">
          <h3 class="subheading">业务</h3>
          <p class="secondary">
            1.面向日本的软件和CG业务 
            <br/>
            2.能源互联网综合服务商
            <br/>
            3.海外企业咨询服务
          </p>
        </div>
        <div class="page-content-bottom-item">
          <h3 class="subheading">团队</h3>
          <p class="secondary">
            1.海外事业部：海外企业咨询服务，面向日本的软件和CG业务
            <br/>
            2.国内事业部：能源互联网综合服务商
            <br/>
            3.核心产品研发部：技术攻坚、核心产品研发
          </p>
        </div>
        <div class="page-content-bottom-item">
          <h3 class="subheading">实力</h3>
          <p class="secondary">
            依托于东悟（日本）集团，与北京分公司、成都分公司联
            合，打造能源、工业领域领先的解决方案,拥有20项软件著
            作权，15项企业研发项目，国际软件开发成熟度认证3级。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page"
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #ffffff;
  padding: 70px 0;
  padding-top: 0px;
  position: relative;

  @media (max-width: 576px) {
    .shape2{
      img{
        display: none;
      }
    }

    .animation{
      display: none;
    }
  }

  .shape {
    position: absolute;
    top: 0px;
    left: 10px;
    z-index: 1;
    opacity: 0.4;

    img {
      animation: rotate 4s linear infinite;
      -webkit-animation: rotate 4s linear infinite;
      
      @-webkit-keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
     
      @keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
    }
  }

  .shape2 {
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 1;
    opacity: 0.2;

    img {
      animation: movebounce 4s linear infinite;
      -webkit-animation: movebounce 4s linear infinite;
    }

    @keyframes movebounce {
      0%,
      100% {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
      }
      
      50% {
        transform: translateY(20px);
        -webkit-transform: translateY(20px);
      }
    }
  }

  .shape3 {
    position: absolute;
    top: 100px;
    right: 80px;
    z-index: 1;
    animation: triangle 20s infinite linear;

    @keyframes triangle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }

  .animation {
    position: absolute;
    top: 120px;
    left: 150px;
    z-index: 1;
    animation: circle 20s infinite linear;

    @-webkit-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-ms-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.page-content {
  align-items: center;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding: 0px;

    .box{
      width: 90%;
      left: 5%;
    }

    .box2{
      display: none;
    }

    .subtitle{
      text-align: center;
    }

    .paragraph {
      text-indent: 25px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    .title {
      background: url(../../assets/img/banner-bg1.jpg) center no-repeat;
    }

    .page-content-top {
      display: block;
      .introduction {
        margin-top: 30px;
      }
    }

    .page-content-bottom {
      display: block;
      margin-top: 30px;
      .page-content-bottom-item {
        margin-top: 30px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.title {
  position: relative;
  font-family: "";
  width: 100%;
  padding-top: 120px;
  padding-bottom: 100px;
  background: url(../../assets/img/banner-bg1.jpg) right top no-repeat;
  
  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
  
  .box2 {
    width: 200px;
    height: 80px;
    position: absolute;
    right: 100px;
    bottom: 4px;
  }
  
  .triangle-box {
    width: 30px;
    height: 30px;
    animation: animate linear 3s infinite;
    -webkit-animation: animate linear 3s infinite;
  }
  
  .triangle {
    width: 30px;
    height: 30px;
    animation: animat linear 5s infinite;
    -webkit-animation: animat linear 5s infinite;
  }
  
  @keyframes animate {
    0%,
    100% {
      transform: translateY(0px);
      -webkit-transform: translateY(0px);
    }

    50% {
      transform: translateY(60px);
      -webkit-transform: translateY(60px);
    }
  }

  @keyframes animat {
    0%,
    100% {
      transform: translateX(0px);
      -webkit-transform: translateX(0px);
    }

    50% {
      transform: translateX(180px);
      -webkit-transform: translateX(180px);
    }
  }
}

.page-content-top {
  display: flex;
  align-items: center;
  padding-top: 60px;

  .introduction {
    padding: 0 15px;
    text-align: left;
    flex: 1;

    .subtitle {
      margin: 0;
      color: #0e314c;
      font-size: 20px;
      font-weight: 600;
    }

    .spacing {
      display: block;
      width: 100%;
      height: 5px;
    }

    .paragraph {
      font-family: "Microsoft YaHei";
      color: #6084a4;
      line-height: 1.9;
      font-size: 14px;
      margin: 10px 0px;
    }

    button {
      background-color: #e36cd9;
      box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
      color: #ffffff;
      border: none;
      padding: 12px 36px;
      position: relative;
      border-radius: 4px;
      z-index: 1;
      text-transform: uppercase;
      -webkit-transition: 0.5s;
      transition: 0.5s;
      font-weight: 600;
      font-size: 13px;
    }
  }
}

.page-content-bottom {
  display: flex;
  margin-top: 60px;
  text-align: left;

  .page-content-bottom-item {
    flex: 1;
    padding: 0 15px;

    .subheading {
      margin: 0;
      color: #0e314c;
      font-size: 16px;
      font-weight: 600;
    }

    .secondary {
      color: #6084a4;
      line-height: 1.9;
      font-size: 13px;
      margin-top: 15px;
      margin-bottom: 20px;
      letter-spacing: 2px;
    }
  }
}

.image {
  position: relative;
  text-align: center;
  flex: 1;
  padding: 0 15px;

  img {
    max-width: 100%;
    height: auto;
  }
}

.box {
  width: 300px;
  height: 150px;
  // border: 1px solid #7aa4c0;
  position: absolute;
  left: 15%;
  bottom: 2%;
}

.ball-box {
  width: 30px;
  height: 30px;
  animation: bouncey linear 3s infinite;
  -webkit-animation: bouncey linear 3s infinite;
}

.ball {
  width: 30px;
  height: 30px;
  animation: bouncex linear 5s infinite;
  -webkit-animation: bouncex linear 5s infinite;
}

@keyframes bouncey {
  0%,
  100% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
  }

  50% {
    transform: translateY(130px);
    -webkit-transform: translateY(130px);
  }
}

@keyframes bouncex {
  0%,
  100% {
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
  }
  
  50% {
    transform: translateX(280px);
    -webkit-transform: translateX(280px);
  }
}
</style>